module.exports = __webpack_public_path__ + "img/face-sad-sweat.17cf5d84.svg";